import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ImageMarquee from '../components/ImageMarquee';

const LeaderCard = ({ leader }) => (
  <div className="flex flex-col items-center text-center w-80">
    <img
      src={leader.image}
      alt={leader.name}
      className="w-80 h-80 object-contain rounded-lg shadow-md bg-gray-50 p-2"
      onError={(e) => { e.target.style.display = 'none'; }}
    />
    <h3 className="mt-4 text-lg font-semibold text-gray-800">
      {leader.name}
    </h3>
    <p className="mt-1 text-sm text-blue-700 font-medium">
      {leader.designation}
    </p>
  </div>
);

const LandingPage = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [natureClubs, setNatureClubs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imageErrors, setImageErrors] = useState(new Set());
  
  const carouselImages = [


    "/images/slide1.jpeg",
    "images/slide2.jpeg",
    "images/slide3.jpeg",
    "images/slide4.jpeg",
    "images/about5.png.jpg",
    "images/about6.png.jpg",
    "/images/mark2.jpg",
    "/images/mark3.jpg",
    "/images/mark4.jpg",
    "/images/mark1.jpg",
  ];
  
  const instituteImagePath = "/images/ins.png";

  const leadership = [
    {
      image: "/images/cmtn.png",
      name: "Thiru C. Joseph Vijay",
      designation: "Hon'ble Chief Minister of Tamil Nadu",
    },
    {
      image: "/images/leader2.jpeg",
      name: "Thiru N. Anand",
      designation: "Hon'ble Minister for Rural Development and Panchayat Raj",
    },
    {
      image: "/images/leader4.jpeg",
      name: "Thiru Prashant M Wadnere, I.A.S.",
      designation: "Secretary to Government, Rural Development and Panchayat Raj Department, Secretariat, Chennai-9",
    },
    {
      image: "/images/leader3.jpeg",
      name: "Dr. R. Anandakumar, I.A.S.",
      designation: "Commissioner of Rural Development and Panchayat Raj, Govt. of Tamil Nadu",
    },
  ];
  
  useEffect(() => {
    const fetchNatureClubs = async () => {
      try {
        const response = await fetch('https://crd-training.in/api/v1/admin/nature');
        const result = await response.json();
        if (result.data) {
          setNatureClubs(result.data);
        }
      } catch (error) {
        console.error('Error fetching nature clubs:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchNatureClubs();
  }, []);
  
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev === carouselImages.length - 1 ? 0 : prev + 1));
    }, 5000);
    
    return () => clearInterval(interval);
  }, [carouselImages.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const handleNatureClubClick = (code) => {
    navigate(`/nature-club/${code}`);
  };

  const handleImageError = (clubId) => {
    setImageErrors(prev => new Set([...prev, clubId]));
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      
      <main className="flex-grow">
        <section className="relative h-[calc(100vh-120px)] md:h-[calc(100vh-100px)] lg:h-[calc(100vh-100px)] overflow-hidden">
          {carouselImages.map((image, index) => (
            <div 
              key={index}
              className={`absolute inset-0 w-full h-full transition-opacity duration-1000 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0 pointer-events-none'
              }`}
            >
              <img 
                src={image} 
                alt={`Background ${index + 1}`} 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black/40"></div>
            </div>
          ))}
       
          <button 
            onClick={() => setCurrentSlide(prev => (prev === 0 ? carouselImages.length - 1 : prev - 1))}
            className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full flex items-center justify-center bg-white/20 text-white hover:bg-white/30 transition-colors backdrop-blur-sm"
            aria-label="Previous slide"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <button 
            onClick={() => setCurrentSlide(prev => (prev === carouselImages.length - 1 ? 0 : prev + 1))}
            className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 rounded-full flex items-center justify-center bg-white/20 text-white hover:bg-white/30 transition-colors backdrop-blur-sm"
            aria-label="Next slide"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>

          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
            {carouselImages.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-2 h-2 rounded-full transition-all ${
                  index === currentSlide ? 'bg-white w-6' : 'bg-white/50'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </section>

        <section className="py-12 bg-white">
          <div className="container mx-auto px-6">
            <div className="max-w-7xl mx-auto">
              <div className="mb-10 text-center">
                <div className="h-0.5 w-20 bg-blue-600 mx-auto mb-6"></div>
                <h2 className="text-3xl font-bold text-gray-800 mb-3">Leadership</h2>
                <p className="text-lg text-gray-600">Guiding our mission forward</p>
              </div>

              {/* Row 1 - Chief Minister */}
              <div className="flex justify-center mb-10">
                <LeaderCard leader={leadership[0]} />
              </div>

              {/* Row 2 - Minister */}
              <div className="flex justify-center mb-10">
                <LeaderCard leader={leadership[1]} />
              </div>

              {/* Row 3 - Officers */}
              <div className="flex flex-wrap justify-center gap-10">
                {leadership.slice(2).map((leader, index) => (
                  <LeaderCard key={index} leader={leader} />
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 bg-gradient-to-b from-green-50 to-white">
          <div className="container mx-auto px-6">
            <div className="max-w-7xl mx-auto">
              <div className="mb-10 text-center">
                <div className="h-0.5 w-20 bg-green-600 mx-auto mb-6"></div>
                <h2 className="text-3xl font-bold text-gray-800 mb-3">SIRD ECO PARK</h2>
                <p className="text-lg text-gray-600">Explore our diverse collection of flora and fauna</p>
              </div>
              
              {loading ? (
                <div className="flex justify-center items-center py-20">
                  <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-green-600"></div>
                </div>
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                  {natureClubs.map((club) => (
                    <div
                      key={club.id}
                      onClick={() => handleNatureClubClick(club.code)}
                      className="bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer overflow-hidden group"
                    >
                      <div className="relative h-48 bg-gradient-to-br from-green-100 to-green-200 flex items-center justify-center overflow-hidden">
                        {club.image && !imageErrors.has(club.id) ? (
                          <img 
                            src={`https://crd-training.in/uploads/nature/${club.image}`}
                            alt={club.name}
                            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                            onError={() => handleImageError(club.id)}
                          />
                        ) : (
                          <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            className="h-20 w-20 text-green-600 group-hover:scale-110 transition-transform duration-300" 
                            fill="none" 
                            viewBox="0 0 24 24" 
                            stroke="currentColor"
                          >
                            <path 
                              strokeLinecap="round" 
                              strokeLinejoin="round" 
                              strokeWidth={1.5} 
                              d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" 
                            />
                          </svg>
                        )}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                      </div>
                      
                      <div className="p-5">
                        <h3 className="text-lg font-semibold text-gray-800 mb-2 group-hover:text-green-600 transition-colors line-clamp-1">
                          {club.name}
                        </h3>
                        <p className="text-sm text-green-700 font-medium mb-2 line-clamp-1">
                          {club.name_ta}
                        </p>
                        {club.common && (
                          <p className="text-xs text-gray-500 italic line-clamp-2">
                            {club.common}
                          </p>
                        )}
                        <div className="mt-4 flex items-center text-green-600 text-sm font-medium group-hover:translate-x-2 transition-transform duration-300">
                          <span>Learn More</span>
                          <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            className="h-4 w-4 ml-1" 
                            fill="none" 
                            viewBox="0 0 24 24" 
                            stroke="currentColor"
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </section>

        <section id="overview" className="py-12 bg-white">
          <div className="container mx-auto px-6">
            <div className="max-w-6xl mx-auto">
              <div className="mb-10">
                <div className="h-0.5 w-20 bg-blue-600 mb-6"></div>
                <div className="bg-gradient-to-r from-blue-50 via-blue-100 to-blue-50 rounded-lg shadow-sm py-5 px-6 mb-8">
                  <h2 className="text-2xl font-semibold text-blue-800 mb-2">COMMISSIONERATE OF RURAL DEVELOPMENT AND PANCHAYAT RAJ (TRAINING)</h2>
                  <p className="text-lg text-gray-700">
                    Rural Development and Panchayat Raj Department, Govt. of Tamil Nadu
                  </p>
                </div>
              </div>
              
              <div className="space-y-10">
                <div className="flex flex-col md:flex-row gap-6">
                  <div className="md:w-16 flex md:justify-start justify-center">
                    <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                      </svg>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-blue-800 mb-3">Commissionerate of Rural Development & Panchayat Raj (Training)</h3>
                    <p className="text-gray-700 leading-relaxed">
                      The Commissionerate of RD&PR (Training) is undertaking all the planning, implementation and monitoring the capacity building and training activities in the state through SRID&PR and five RIRD&PR. The Commissionerate is headed by a senior officer in the rank of Additional Chief Secretary who is also the Vice-Chairman of SIRD&PR society. An officer in the cadre of Additional Director is in-charge for the training related activities and functioning from State Institute of Rural Development and Panchayat Raj as its Director.
                    </p>
                  </div>
                </div>
                
                <div className="flex flex-col md:flex-row gap-6">
                  <div className="md:w-16 flex md:justify-start justify-center">
                    <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                      </svg>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-blue-800 mb-3">Our Mission & History</h3>
                    <p className="text-gray-700 leading-relaxed">
                      Rural Development and Panchayat Raj Department at State level undertakes various capacity building and research activities. SIRD&PR Conceptualizes, Designs, Organizes, Coordinates and Monitors training and Capacity Building of the elected representatives of three tier Panchayat Raj Institutions, Officials of RD&PR and other line departments, CBOs and general Public. The Institute was established in 1990 and registered under Tamil Nadu Societies Registration Act, 1975. Presently the Institute is functioning in a 25 acre campus at Maraimalainagar, near Chennai.
                    </p>
                  </div>
                </div>
                
                <div className="flex flex-col md:flex-row gap-6">
                  <div className="md:w-16 flex md:justify-start justify-center">
                    <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h.5A2.5 2.5 0 0020 5.5v-1.65M12 14.5V17m0 0v2.5M12 17h2.5M12 17h-2.5" />
                      </svg>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-blue-800 mb-3">Regional Institutes Network</h3>
                    <p className="text-gray-700 leading-relaxed">
                      The Regional Institutes of Rural Development & Panchayat Raj at Sathiya Vijaya Nagaram in Tiruvannamalai district, Krishnagiri in Krishnagiri district, Pattukottai, in Thanjavur district, Bhavanisagar in Erode district and T.Kallupatty in Madurai district are entrusted with the task of imparting training. RIRD & PRs are headed by Principals in the cadre of Additional Director/Joint Director of Rural Development and Panchayat Raj Department.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 bg-gray-50">
          <div className="container mx-auto px-6">
            <div className="max-w-6xl mx-auto">
              <div className="mb-10 text-center">
                <h2 className="text-2xl font-bold text-gray-800 mb-3">Our Institutes</h2>
                <div className="h-0.5 w-20 bg-blue-600 mx-auto mb-6"></div>
              </div>
              
              <div className="rounded-lg overflow-hidden shadow-lg">
                <img 
                  src={instituteImagePath} 
                  alt="Our Institutes Network" 
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>
        </section>
        
        <ImageMarquee />
      </main>
      
      <Footer />

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        
        .animate-fade-in-up {
          animation: fadeInUp 0.8s ease-out forwards;
        }
        
        .animate-fade-in {
          animation: fadeIn 1s ease-out forwards;
          animation-delay: 0.3s;
          opacity: 0;
        }
        
        .shadow-text {
          text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);
        }
      `}</style>
    </div>
  );
};

export default LandingPage;